import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../ui/FadeIn';
export function ProofSection() {
  return <section className="bg-cream py-24 px-6" data-id="element-181">
      <div className="max-w-4xl mx-auto text-center" data-id="element-182">
        <FadeIn data-id="element-183">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-12" data-id="element-184">
            La Transformación de 21 Días
          </h2>
        </FadeIn>

        <StaggerContainer className="space-y-8 text-left" data-id="element-185">
          <StaggerItem className="bg-white p-8 rounded-sm shadow-sm border-l-4 border-copper" data-id="element-186">
            <h4 className="text-copper font-bold uppercase tracking-wider text-sm mb-2" data-id="element-187">
              Semana 1
            </h4>
            <p className="text-xl text-charcoal/80 font-serif" data-id="element-188">
              Notarás cómo la ropa deja de apretar. La inflamación abdominal
              comienza a ceder visiblemente.
            </p>
          </StaggerItem>

          <StaggerItem className="bg-white p-8 rounded-sm shadow-sm border-l-4 border-copper ml-0 md:ml-8" data-id="element-189">
            <h4 className="text-copper font-bold uppercase tracking-wider text-sm mb-2" data-id="element-190">
              Semana 2
            </h4>
            <p className="text-xl text-charcoal/80 font-serif" data-id="element-191">
              La niebla mental desaparece. Te sientes enfocada, con energía
              estable durante todo el día y sin bajones a media tarde.
            </p>
          </StaggerItem>

          <StaggerItem className="bg-white p-8 rounded-sm shadow-sm border-l-4 border-copper ml-0 md:ml-16" data-id="element-192">
            <h4 className="text-copper font-bold uppercase tracking-wider text-sm mb-2" data-id="element-193">
              Día 21
            </h4>
            <p className="text-xl text-charcoal/80 font-serif" data-id="element-194">
              Habrás establecido una rutina de bienestar que no solo desinflama
              tu cuerpo, sino que calma tu mente y espíritu. Te sientes dueña de
              tu cuerpo otra vez.
            </p>
          </StaggerItem>
        </StaggerContainer>
      </div>
    </section>;
}